import { forwardRef } from 'react';

const variants = {
  success: 'bg-success/10 text-success border-success/20',
  danger: 'bg-danger/10 text-danger border-danger/20',
  warning: 'bg-warning/10 text-warning border-warning/20',
  info: 'bg-accent-blue/10 text-accent-blue border-accent-blue/20',
  neutral: 'bg-border/20 text-text-secondary border-border',
};

const sizes = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-3 py-1 text-sm',
  lg: 'px-4 py-1.5 text-base',
};

const Badge = forwardRef(({
  children,
  variant = 'neutral',
  size = 'md',
  className = '',
  ...props
}, ref) => {
  const variantClasses = variants[variant] || variants.neutral;
  const sizeClasses = sizes[size] || sizes.md;

  return (
    <span
      ref={ref}
      className={`
        ${variantClasses}
        ${sizeClasses}
        inline-flex items-center
        font-semibold rounded-full
        border
        ${className}
      `}
      {...props}
    >
      {children}
    </span>
  );
});

Badge.displayName = 'Badge';

export default Badge;
